function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Vue from 'vue';
import { isSSR } from './Platform.js';
import { noop } from '../utils/event.js';
import { isObject } from '../utils/is.js';
import QAjaxBar from '../components/ajax-bar/QAjaxBar.js';
export default {
  isActive: false,
  start: noop,
  stop: noop,
  increment: noop,
  setDefaults: noop,
  install: function install(_ref) {
    var _this = this;

    var $q = _ref.$q,
        cfg = _ref.cfg;
    $q.loadingBar = this;

    if (isSSR === true) {
      return;
    }

    var props = cfg.loadingBar !== void 0 ? _objectSpread({}, cfg.loadingBar) : {};
    var on = {
      start: function start() {
        _this.isActive = true;
      },
      stop: function stop() {
        _this.isActive = false;
      }
    };
    var bar = new Vue({
      name: 'LoadingBar',
      // hide App from Vue devtools
      devtools: {
        hide: true
      },
      beforeCreate: function beforeCreate() {
        // prevent error in Vue devtools
        this._routerRoot === void 0 && (this._routerRoot = {});
      },
      render: function render(h) {
        return h(QAjaxBar, {
          ref: 'bar',
          props: props,
          on: on
        });
      }
    }).$mount().$refs.bar;
    Object.assign(this, {
      start: bar.start,
      stop: bar.stop,
      increment: bar.increment,
      setDefaults: function setDefaults(opts) {
        isObject(opts) === true && Object.assign(props, opts);
        bar.$parent.$forceUpdate();
      }
    });
    Vue.util.defineReactive(this, 'isActive', this.isActive);
    Vue.util.defineReactive(bar, 'isActive', this.isActive);
    bar.setDefaults = this.setDefaults;
    document.body.appendChild(bar.$parent.$el);
  }
};